<template>
	<div class="date-range-container">
		<date-range-picker v-model="dateRange"
			:startDate="dateRange.startDate"
			:endDate="dateRange.endDate"
			@update="onUpdateDateRange()"
			@toggle="removeBodyScroll()"
			:locale-data="locale"
			:opens="opens" >
			<div slot="input" slot-scope="picker">
				<span v-if="startDate && endDate">{{prettyDateTime(dateRange.startDate)}} - {{prettyDateTime(dateRange.endDate)}}</span>
				<span v-else class="placeholder">Select Date</span>
				<i class="fas fa-calendar icon"></i>
			</div>
		</date-range-picker>
	</div>
</template>

<script>
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';
import { prettyDateTime } from '@/modules/utilities';

export default {
	props: ['startDate', 'endDate', 'onChangeDate'],
	components: {
		DateRangePicker,
	},
	data() {
		return {
			dateRange: {
				startDate: moment().format('YYYY/MM-DD'),
				endDate: moment().add(7, 'days').format('YYYY/MM/DD'),
			},
			opens: 'right',
			locale: {
				direction: 'ltr',
				format: 'DD-MM-YYYY',
				separator: ' - ',
				applyLabel: 'Apply',
				cancelLabel: 'Cancel',
				weekLabel: 'W',
				customRangeLabel: 'Custom Range',
				daysOfWeek: moment.weekdaysMin(),
				monthNames: moment.monthsShort(),
				firstDay: 1,
				showWeekNumbers: true,
			},
		};
	},
	created() {
		this.dateRange.startDate = this.setStartDate(this.startDate);
		this.dateRange.endDate = this.setEndDate(this.endDate);
	},
	methods: {
		prettyDateTime,
		setStartDate(date) {
			if (date) {
				return moment(date).format('YYYY/MM-DD');
			}
			return date;
		},
		setEndDate(date) {
			if (date) {
				return moment(date).format('YYYY/MM-DD');
			}
			return date;
		},
		removeBodyScroll() {
			const mobileWidth = 575.98;
			console.log('mobileWidth');
			if (window.innerWidth <= mobileWidth) {
				// hide body scroll
				if (document.body.classList.contains('modal-opened')) {
					document.body.className = '';
				} else {
					document.body.className = 'modal-opened';
				}
			}
		},
		onUpdateDateRange() {
			const dateRange = {
				startDate: moment(this.dateRange.startDate).format('DD-MM-YYYY'),
				endDate: moment(this.dateRange.endDate).format('DD-MM-YYYY'),
			};
			this.onChangeDate(dateRange);
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/elements/DateRangePicker.vue